<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{$t('')}}<template slot="title">{{$t('')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+''" />
      </a-form-model-item>
      <a-form-model-item prop="activityId" >
        <span slot="label" ><a-tooltip>{{$t('活动ID')}}<template slot="title">{{$t('活动ID')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.activityId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'活动ID'" />
      </a-form-model-item>
      <a-form-model-item prop="prizeId" >
        <span slot="label" ><a-tooltip>{{$t('奖品ID')}}<template slot="title">{{$t('奖品ID')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.prizeId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'奖品ID'" />
      </a-form-model-item>
      <a-form-model-item prop="prizeName" >
        <span slot="label" ><a-tooltip>{{$t('奖品名称')}}<template slot="title">{{$t('奖品名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.prizeName" :maxLength="100" :placeholder="$t('请输入')+'奖品名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="prizeType" >
        <span slot="label" ><a-tooltip>{{$t('1谢谢参与2积分3优惠券4实物')}}<template slot="title">{{$t('1谢谢参与2积分3优惠券4实物')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('1中奖 2已领取 3已发货')}}<template slot="title">{{$t('1中奖 2已领取 3已发货')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="addressStatus" >
        <span slot="label" ><a-tooltip>{{$t('0未填写 1已填写')}}<template slot="title">{{$t('0未填写 1已填写')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="createdAt" >
        <span slot="label" ><a-tooltip>{{$t('')}}<template slot="title">{{$t('')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.createdAt" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getLotteryRecord, addLotteryRecord, updateLotteryRecord } from '@/api/lottery/lotteryRecord'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        activityId: null,
        prizeId: null,
        prizeName: null,
        prizeType: null,
        status: 0,
        addressStatus: 0,
        createdAt: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        activityId: null,
        prizeId: null,
        prizeName: null,
        prizeType: null,
        status: 0,
        addressStatus: 0,
        createdAt: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLotteryRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateLotteryRecord(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLotteryRecord(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
